<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <div
      class="shadow-lg bg-n-slate-12 text-white dark:bg-n-solid-2 dark:text-n-slate-12 rounded-lg items-center gap-3 inline-flex mb-2 max-w-[25rem] min-h-[1.875rem] min-w-[15rem] px-6 py-3 text-left"
    >
      <div class="text-sm font-medium">
        {{ message }}
      </div>
      <div v-if="action">
        <router-link
          v-if="action.type == 'link'"
          :to="action.to"
          class="font-semibold cursor-pointer select-none text-white underline decoration-white/60 hover:text-white dark:text-n-blue-10 dark:decoration-n-blue-10 dark:hover:text-n-blue-8"
        >
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>
